<template>
  <div id="spinner" class="spinner spinner-block" :class="{'show': isReady}">
    <div class="spinner-bar"></div>
  </div>
</template>

<script>
export default {
  name: 'appSpinner',
  data () {
    return {
      running: false
    }
  },
  mounted () {
    this.$bus.$on('spinner-run', result => {
      this.run()
    })
    this.$bus.$on('spinner-stop', result => {
      this.stop()
    })
  },
  methods: {
    run () {
      this.running = true
    },
    stop () {
      this.running = false
    }
  },
  computed: {
    isReady () {
      return this.running
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/theme/Spinner.vue